import {Row} from "antd";
import React, {useEffect, useState} from "react";
import {fetchPageDetails} from "../../../store/CommonSlice";
import {useAppDispatch} from "../../../store/app";
import {Helmet, HelmetProvider} from "react-helmet-async";
// import { smoothScrollTo } from "../../../utils/GlobalFunction";

const Policy: React.FC<any> = () => {
    // const privacyContantRef = useRef<HTMLDivElement | null>(null)
    // useEffect(() => {
    //     smoothScrollTo(privacyContantRef)
    // })

    const dispatch = useAppDispatch();
    const defaultState = {
        id: 0,
        page_title: "",
        content: "",
        meta_title: "",
        meta_description: "",
    };
    const [pageDetails, setPageDetails] = useState(defaultState);
    useEffect(() => {
        dispatch(fetchPageDetails({slug: "privacy-policy"}))
            .then((data: any) => {
                setPageDetails(data?.data);
            })
            .catch((error: any) => {
                console.log(error);
            });
    }, []);
    const createMarkup = (text: any) => {
        return {__html: text};
    };

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <meta name="title" content={pageDetails?.meta_title} />
                    <meta name="description" content={pageDetails?.meta_description} />
                </Helmet>
            </HelmetProvider>
            <section className="section whyThisSection contentSection" id="kapturely">
                <div className="container">
                    <Row className="heading">
                        <h2>{pageDetails?.page_title}</h2>
                    </Row>
                    <Row>
                        <div dangerouslySetInnerHTML={createMarkup(pageDetails?.content)} />
                    </Row>
                </div>
            </section>
        </>
    );
};

export default Policy;
